import { memo, ReactNode } from 'react'
import { Typography, Box, IconButton } from '@astro-ui/components'
import { ArrowLeft } from '@astronautsid/wpe-icons'

interface HeaderPropsType {
  RightComponent?: ReactNode
  LeftComponent?: ReactNode
  title?: ReactNode
  subtitle?: string
  withBackButton?: boolean
  handleGoBack?: () => void
}

const Header = ({
  RightComponent,
  LeftComponent,
  title = 'Title',
  subtitle = '',
  withBackButton = false,
  handleGoBack = () => {
    //
  },
}: HeaderPropsType) => (
  <Box
    display="flex"
    marginBottom="24px"
    justifyContent={typeof RightComponent !== 'undefined' ? 'space-between' : 'flex-start'}
    alignItems="center"
  >
    <Box display="flex" alignItems="center" gap="10px">
      {withBackButton && (
        <IconButton onClick={handleGoBack} sx={{ minWidth: 'unset' }}>
          <ArrowLeft color="#646464" />
        </IconButton>
      )}
      {typeof title === 'string' ? (
        <Box display="flex" flexDirection="column" gap="4px" mt="4px">
          <Typography variant="display-tiny">{title}</Typography>
          {subtitle && <Typography>{subtitle}</Typography>}
        </Box>
      ) : (
        title
      )}
      {LeftComponent && <Box>{LeftComponent}</Box>}
    </Box>
    {RightComponent && <Box>{RightComponent}</Box>}
  </Box>
)

export default memo(Header)
